<template>
  <v-flex xs12 text-xs-right>
    <h1 class="davi-curs font-red" v-html="textTitle"></h1>
  </v-flex>
</template>

<script>
export default {
  props: {
    textTitle: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.font-red {
  font-size: 1.4em;
  margin: 5px auto;
  line-height: 1.1em;
}

@media (min-width: 600px) {
  .font-red {
    font-size: 2em;
  }
}
</style>




// WEBPACK FOOTER //
// Titlered.vue?dec13cac